import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';

type DrawerProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children?: React.ReactNode;
  side?: 'left' | 'right';
  className?: string;
};

const Drawer: React.FC<DrawerProps> = ({ open, onOpenChange, children, side = 'right', className = '' }) => {
  const sideClass = side === 'left' ? 'left-0' : 'right-0';

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/60 z-[9000]" />
        <Dialog.Content
          className={`fixed top-0 h-full z-[9100] p-0 flex ${side === 'right' ? 'justify-end' : 'justify-start'} ${className}`}
          style={{ [side]: 0 }}
          aria-describedby={undefined}
        >
          <Dialog.Title className="sr-only">Navigation Drawer</Dialog.Title>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default Drawer;
